var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 79,
    viewBox: "0 0 200 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8928 30.5854C25.8664 30.5854 19.3592 37.0918 19.3592 45.119C19.3592 53.1454 25.8664 59.6518 33.8928 59.6518",
    fill: "#0A0A28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78717 30.5854C17.8144 30.5854 24.3208 37.0918 24.3208 45.119C24.3208 53.1454 17.8144 59.6518 9.78717 59.6518",
    fill: "#4747D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2472 59.6185H41.3448V30.3809H51.9168C60.2176 30.3809 68.6424 33.8497 68.6424 44.9169C68.6424 55.2001 60.3 59.6185 52.2472 59.6185ZM51.752 36.4105H48.2416V53.5065H51.5872C56.6248 53.5065 61.292 51.4425 61.292 44.9177C61.2912 38.3513 56.6248 36.4105 51.752 36.4105Z",
    fill: "#0A0A28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3072 59.6185V30.3809H80.4104V59.6185H73.3072Z",
    fill: "#0A0A28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.811 60.4031C91.808 60.4031 85.076 54.1263 85.076 44.9583C85.076 35.5839 92.0136 29.5959 100.934 29.5959C105.022 29.5959 109.441 31.0823 111.878 33.8911L107.088 38.6815C105.766 36.8647 103.413 35.9975 101.183 35.9975C96.2672 35.9975 92.7576 39.7967 92.7576 44.9591C92.7576 50.2863 96.1856 53.9207 101.058 53.9207C103.825 53.9207 106.014 52.6815 107.253 50.9471L112.167 55.5719C109.606 58.5455 105.725 60.4031 100.811 60.4031Z",
    fill: "#0A0A28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.222 60.4031C120.095 60.4031 113.322 54.1263 113.322 44.8759C113.322 35.5015 120.095 29.5959 129.222 29.5959C138.389 29.5959 145.162 35.5015 145.162 44.8759C145.162 54.1263 138.389 60.4031 129.222 60.4031ZM129.222 35.9559C124.266 35.9559 120.879 39.7551 120.879 44.8759C120.879 50.1607 124.307 53.9607 129.222 53.9607C134.136 53.9607 137.605 50.1607 137.605 44.8759C137.605 39.7551 134.177 35.9559 129.222 35.9559Z",
    fill: "#0A0A28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.102 36.4105V59.6193H154.039V36.4105H145.78V30.3809H169.362V36.4105H161.102Z",
    fill: "#0A0A28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.47 26.6031V22.4511H178.987V21.6055H182.958V22.4511H181.479V26.6031H180.47Z",
    fill: "#0A0A28"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.595 26.6031V21.6047H185.106L186.014 25.0143L186.91 21.6047H188.424V26.6031H187.486V22.6687L186.494 26.6031H185.522L184.535 22.6687V26.6031H183.595Z",
    fill: "#0A0A28"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M183.705 30.6119C187.299 30.6119 190.213 27.6982 190.213 24.104C190.213 20.5097 187.299 17.5959 183.705 17.5959C180.111 17.5959 177.197 20.5097 177.197 24.104C177.197 27.6982 180.111 30.6119 183.705 30.6119Z",
    stroke: "#0A0A28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.619d55260fdcfc45c97bebad254caee9.svg";
export { ForwardRef as ReactComponent };